import SecuritySetting from './SecuritySetting'

export default SecuritySetting
